const normalize = (text) => text
  .toLowerCase()
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "");

export const createMockReply = (prompt) => {
  const message = normalize(prompt);
  let text;
  let artifactId;

  if (/grafico|gere\s+(um\s+)?bi/.test(message)) {
    text = "Preparei o Painel comercial para você. Ele reúne vendas e recebimentos por empreendimento com dados ilustrativos.";
    artifactId = "painel-comercial";
  } else if (/vend|comercial|cliente|lead/.test(message)) {
    text = "Posso organizar um resumo de vendas por período ou empreendimento. Por enquanto, os números exibidos no AIPO são ilustrativos.";
  } else if (/receb|pagament|financeir|inadimpl/.test(message)) {
    text = "Posso ajudar a acompanhar recebimentos e pendências financeiras. Ainda não consulto os sistemas conectados nesta conversa.";
  } else if (/projet|obra|empreend|construc/.test(message)) {
    text = "Podemos reunir as informações desse projeto em um só lugar. Me diga qual empreendimento ou etapa você quer acompanhar.";
  } else if (/credit|plano|consumo/.test(message)) {
    text = "O painel mostra os créditos disponíveis e o consumo do período. Esses valores ainda são ilustrativos e não refletem o saldo real da conta.";
  } else if (/\b(oi|ola|bom dia|boa tarde|boa noite|ajuda)\b/.test(message)) {
    text = "Olá! Posso ajudar com projetos, vendas, recebimentos e créditos. O que você gostaria de explorar?";
  } else {
    text = "Recebi sua mensagem. Posso ajudar a resumir esse assunto ou organizar os próximos passos. Ainda não consulto dados reais nesta conversa.";
  }

  return { role: "assistant", text, visualization: false, artifactId };
};
